import { Flex } from '@chakra-ui/react';
import { EmptyState } from 'components/ds';
import { Inbox } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Empty = ({ content }) => {
  const { t } = useTranslation();
  return (
    <Flex align='center' justify='center' w='100%' h='100%'>
      {content ? (
        <Flex justify='center' p='16px'>
          {content}
        </Flex>
      ) : (
        <EmptyState icon={<Inbox size={26} />} title={t('common.noData')} />
      )}
    </Flex>
  );
};

export default Empty;
